import { useQuery } from 'react-query';
import { statsByMonthQuery } from './useStatsByMonth.query';
import { UseStatsByMonthOptions } from './useStatsByMonth.types';
import {
  StatsByMonthRequestData,
  StatsResultsResponseRow,
} from '../../../types/api/endpoints/stats/results.types';

export const STATS_RESULTS_BY_DAY_QUERY_KEY = 'STATS_RESULTS_BY_DAY';

export const useStatsByMonth = (
  data: StatsByMonthRequestData,
  options?: UseStatsByMonthOptions
) => {
  return useQuery<StatsResultsResponseRow[], Error>(
    [STATS_RESULTS_BY_DAY_QUERY_KEY, data],
    () => statsByMonthQuery(data),
    options
  );
};
